// OneUX's <bb-alert> fires a cancelable `close` when its X is clicked and, unless the event is
// cancelled, removes itself from the DOM. Every dismissible alert in Halo is state-driven
// (`v-if="msg"` + `@close="msg = null"`), so letting bb-alert remove itself detaches the node from
// under Vue: when the same message comes back (close the alert, submit again, get the same 409)
// the v-if patches against that detached node and the alert is lost or misplaced.
//
// Cancel the close for every bb-alert so `@close` owns visibility. Vue's own `@close` handler runs
// first (it sits on the element); this document-level listener runs after it, during bubbling.
document.addEventListener('close', (event) => {
  if ((event.target as Element | null)?.localName === 'bb-alert') {
    event.preventDefault();
  }
});
